import { render, staticRenderFns } from "./CompraDetalhesComprador.vue?vue&type=template&id=8aa0f340"
import script from "./CompraDetalhesComprador.vue?vue&type=script&lang=js"
export * from "./CompraDetalhesComprador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports